/**
 * 현장 통합서버 배포(원격) 다이얼로그의 계산부 — 사내 서버에서 검증한 이미지를 현장으로
 * 승격한다(site-deploy.yaml). 다이얼로그와 분리해 테스트한다.
 */
import type { SiteNetworkDevice } from '../../../models/SiteNetworkDevice';
import type { ServiceVersion } from '../../../models/ServiceVersion';
import { CATEGORY_INTEGRATION_SERVER } from '../../../pages/SiteSettingsPage/HealthTargetCard';
import type { SelectionMap } from './useDeployServiceSelection';

/** 이 현장의 원격 배포 대상 — IP 가 있는 통합서버만, 방재실·이름 순. */
export function integrationServers(devices: SiteNetworkDevice[]): SiteNetworkDevice[] {
  return devices
    .filter((d) => d.category === CATEGORY_INTEGRATION_SERVER && d.ip_address.trim() !== '')
    .sort(
      (a, b) =>
        (a.health_group ?? '').localeCompare(b.health_group ?? '') || a.name.localeCompare(b.name),
    );
}

/** "3bl · 통합서버 (172.23.90.168)" */
export function serverLabel(d: SiteNetworkDevice): string {
  const group = d.health_group ? `${d.health_group} · ` : '';
  return `${group}${d.name} (${d.ip_address.trim()})`;
}

const SEMVER = /^v\d+\.\d+\.\d+$/;

/**
 * 원격 배포 기본 선택: 사내 서버에서 이 현장으로 떠 있는 버전을 그대로 올린다.
 * 사내 버전을 모르는 서비스(사내가 다른 현장을 돌리는 중·컨테이너 없음·:latest 뿐)는
 * 배포안함으로 둔다 — 운영자가 직접 버전을 골라야 올라간다.
 */
export function remoteDefaultSelection(
  appnames: readonly string[],
  company: ServiceVersion[] | null,
): SelectionMap {
  return new Map(
    appnames.map((app) => {
      const v = company?.find((c) => c.app === app);
      return [
        app,
        v && v.state !== 'missing' && SEMVER.test(v.version)
          ? { mode: 'reuse' as const, target_version: v.version }
          : { mode: 'skip' as const },
      ];
    }),
  );
}
